export default {
    data() {
        return {
            user: null
        }
    },
    created() {
        this.fetchUser(false);
    },
    methods: {
        async fetchUser(force = true) {
            this.setUser();

            if (this.user && !force) {
                return;
            }

            try {
                const { data } = await axios.get("/api/user");
                const userData = btoa(unescape(encodeURIComponent(JSON.stringify(data.data))));
                localStorage.setItem('user', userData);

                this.setUser();
            } catch (errors) {
                this.$toastr.e(this.$t("toastr.errorMessage"), this.$t("toastr.error"));
            }
        },
        setUser() {
            try {
                const userData = localStorage.getItem('user');
                this.user = userData && decodeURIComponent(escape(atob(userData))) != 'undefined' ?
                    JSON.parse(decodeURIComponent(escape(atob(userData)))) : undefined;
                this.ready = true;
            } catch (errors) {
                localStorage.removeItem('user');
                window.location = '/login';
            }
        }
    },
};
